<template>
    <div
        v-if="(small || medium) && isMobileMenuShown"
        class="top-menu-full-screen"
    >
        <mega-menu-small-screen
            :options="options"
            :website-type="websiteType"
        />
    </div>
</template>
<script>
import HeaderBaseMixinVue from '../HeaderBaseMixin.vue';
import MegaMenuSmallScreenVue from './MegaMenuSmallScreen.vue';

export default {
    name: 'TopMenuMobile',
    components: {
        'mega-menu-small-screen': MegaMenuSmallScreenVue
    },
    mixins: [
        HeaderBaseMixinVue
    ],
    props: {
        options: {
            type: Object,
            default() {
                return {};
            }
        },
        classes: {
            type: String,
            default() {
                return '';
            }
        }
    },
    computed: {
        topMenuStyle() {
            return {
                top: `${this.$store.state.header.height}px`
            };
        }
    },
    mounted() {
    }
};
</script>
<style lang="scss" scoped>
@import '../header';

.top-menu-full-screen{
    height: 100vh;
    width: 100vw;
    z-index: 500;
    overflow: scroll;
}
</style>
